export default "__VITE_ASSET__CRoh4Ru6__"